import clsx from "clsx";
import { FunctionComponent } from "react";

import { useComponentConfig } from "@ui/context/component-config-context";
import useDefaults from "@ui/hooks/use-defaults";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

import * as styles from "./Category.css";

export interface MetaCategoryBaseConfig {
  showSuperCats?: boolean;
  categorySeparator?: string | React.ReactNode;
  metaVariation?: keyof typeof styles.container;
  vertical?: boolean;
}

export interface Props extends Partial<MetaCategoryBaseConfig> {
  category: string;
  className?: string;
  componentContext?: string;
  path?: string;
}

const Category: FunctionComponent<Props> = (props) => {
  const { category, className, componentContext, path } = props;
  const analytics = useAnalytics();
  const metaCategoryConfig = useComponentConfig(
    "metaCategory",
    componentContext || "",
  );

  const { metaVariation = "standard", vertical } = useDefaults(
    props,
    metaCategoryConfig,
  );

  const allStyles = clsx(
    styles.container[metaVariation],
    vertical && styles.verticalPosition,
    className,
  );

  return path ? (
    <a
      href={path}
      onClick={() =>
        analytics?.emit({
          event: "breadcrumb",
          breadcrumb: {
            platform: category,
          },
        })
      }
      className={allStyles}
    >
      {category}
    </a>
  ) : (
    <span className={allStyles}>{category}</span>
  );
};

export default Category;
